import { userReducer } from "./user.reducer";
import { fhirReducer } from "./fhir.reducer";
import {
  questionnaireReducer,
  ifqModuleSettingReducer
} from "@zitelab/ionic-fhir-questionnaires";
import { ActionReducerMap } from "@ngrx/store";
import { AppState } from "../../models/app.state";
import { patientReducer } from "./patient.reducer";
import { supportActionReducer } from "./support-action.reducer";
import { manualItemReducer } from "./manual-item.reducer";
import { evaluationReducer } from "./evaluation.reducer";
import { hcpUserReducer } from "./hcp-user.reducer";
import { configReducer } from "./config.reducer";
import { newsReducer } from "./news.reducer";
import { serviceMessagesReducer } from "./service-message.reducer";

export const reducers: ActionReducerMap<AppState> = {
  user: userReducer,
  config: configReducer,
  patients: patientReducer,
  hcpUsers: hcpUserReducer,
  fhir: fhirReducer,
  ifqSettings: ifqModuleSettingReducer,
  questionnaires: questionnaireReducer,
  supportActions: supportActionReducer,
  manualItems: manualItemReducer,
  evaluation: evaluationReducer,
  news: newsReducer,
  serviceMessages: serviceMessagesReducer
};



// WEBPACK FOOTER //
// ./src/app/store/reducers/root.reducer.ts